import { render, staticRenderFns } from "./standardTariff.vue?vue&type=template&id=32fb0464&scoped=true"
import script from "./standardTariff.vue?vue&type=script&lang=js"
export * from "./standardTariff.vue?vue&type=script&lang=js"
import style0 from "./standardTariff.vue?vue&type=style&index=0&id=32fb0464&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fb0464",
  null
  
)

export default component.exports